import { SSOEnvironmentModel } from '../environment.model';

export const oktaSsoEnabled: SSOEnvironmentModel = {
  showOktaLoginButton: true,
  ssoFlow: true,
  okta: {
    SSOCredentials: {
      issuer: 'https://safeguard-dev.oktapreview.com/oauth2/aus2o902flb3fHbRi1d7',
      clientId: '0oa7d4737sfTqbnqz1d7' // '0oa6yh9s06IxzLUPV1d7',
    },
  },
};
